import { render, staticRenderFns } from "./TabView.vue?vue&type=template&id=f4728206&scoped=true&"
import script from "./TabView.vue?vue&type=script&lang=js&"
export * from "./TabView.vue?vue&type=script&lang=js&"
import style0 from "./TabView.vue?vue&type=style&index=0&id=f4728206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4728206",
  null
  
)

export default component.exports